<template>
	<div class="slider">
		<div class="swiper-container">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide"
					:style="{ backgroundImage: 'url(' + require('@/assets/images/disco01.jpg') + ')' }">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Slide'
}
</script>